import { useState, useEffect } from 'react';
import { useBookingService } from '../../services/bookings/BookingServiceProvider';
import { Facility } from '../../model/facilities/Facility';
import { PlayingMember } from '../../model/members/PlayingMember';
/**
 * Custom hook to fetch facility metadata for a booking
 */
export const useBookingFactory = (facilityName: string) => {
  const [facility, setFacility] = useState<Facility | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const [members] = useState<PlayingMember[]>([]);
  const bookingService = useBookingService();
  
  useEffect(() => {
    // Reset state when facility name changes
    setFacility(null);
    
    const fetchFacility = async () => {
      // Only proceed if we have a valid facility name
      if (!facilityName) {
        setIsLoading(false);
        return;
      }
      
      try {
        setIsLoading(true);
        const metadata = await bookingService.getFacility(facilityName);
        setFacility(metadata);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(`Failed to fetch facility: ${facilityName}`));
        console.error(`Error fetching facility ${facilityName}:`, err);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchFacility();
  }, [facilityName, bookingService]);
  
  // Return the booking service as well so it can be used by consumers
  return { facility, isLoading, error, bookingService, members };
};